import MonitoringModule from '@pages/monitoring/MonitoringModule'
import UpcomingMeetings from '@pages/monitoring/UpcomingMeetings'
import InProgressMeetings from '@pages/monitoring/InProgressMeetings'

export default {
    path: 'monitoring',
    component: MonitoringModule,
    children: [
        {
            path: 'growth-metrics',
            name: 'growthMetrics',
            component: () => import('@pages/monitoring/GrowthMetrics'),
        },
        {
            path: 'audits',
            name: 'audits',
            component: () => import('@pages/monitoring/Audits/Index'),
        },
        {
            path: 'contact-logs',
            name: 'contact-logs',
            component: () => import('@pages/monitoring/emailContactLogs/Index'),
        },
    ],
}
